// extracted by mini-css-extract-plugin
export default {"expandBtn":"ExpandIcon_expandBtn__CKQWO","icon":"ExpandIcon_icon__GtWz+","expanded":"ExpandIcon_expanded__nkOGX"};